import { render } from "./NoticeBox.vue?vue&type=template&id=7c03429a&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./NoticeBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./NoticeBox.vue?vue&type=style&index=0&id=7c03429a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c03429a"]])

export default __exports__